import { useLayoutEffect, useMemo } from "react";
import { injectPlainCss, resolveElementId } from "../utils/injectPlainCss.js";
/**
 * Dynamically creates a style-tag in your head with a given plain CSS string.
 */ function usePlainCss(css, elementId, keep) {
    const id = useMemo(()=>resolveElementId(elementId), [
        elementId
    ]);
    useLayoutEffect(()=>{
        const injectedId = injectPlainCss(css, id);
        return ()=>{
            if (!keep) {
                document.getElementById(injectedId)?.remove();
            }
        };
    }, [
        css,
        id,
        keep
    ]);
    return id;
}
export { usePlainCss };
